import { Array } from "@siteimprove/alfa-array";
import { Equatable } from "@siteimprove/alfa-equatable";
import * as earl from "@siteimprove/alfa-earl";
import * as json from "@siteimprove/alfa-json";
import * as sarif from "@siteimprove/alfa-sarif";
/**
 * @public
 */
export class Group {
    static of(members) {
        return new Group(Array.from(members));
    }
    _members;
    constructor(members) {
        this._members = members;
    }
    get size() {
        return this._members.length;
    }
    *[Symbol.iterator]() {
        yield* this._members;
    }
    equals(value) {
        return (value instanceof Group &&
            value._members.length === this._members.length &&
            value._members.every((member, i) => Equatable.equals(member, this._members[i])));
    }
    hash(hash) {
        for (const member of this._members) {
            member.hash(hash);
        }
    }
    toJSON(options) {
        return this._members.map((member) => json.Serializable.toJSON(member, options));
    }
    toEARL() {
        return {
            "@context": {
                ptr: "http://www.w3.org/2009/pointers#",
            },
            "@type": ["ptr:Pointer", "ptr:PointersGroup", "ptr:RelatedPointers"],
            "ptr:groupPointer": {
                "@list": Array.collect(this._members, (member) => earl.Serializable.toEARL(member)),
            },
        };
    }
    toSARIF() {
        return {
            logicalLocations: Array.flatMap(this._members, (member) => sarif.Serializable.toSARIF(member)
                .map((location) => location.logicalLocations ?? [])
                .getOr([])),
        };
    }
}
/**
 * @public
 */
(function (Group) {
    function isGroup(value) {
        return value instanceof Group;
    }
    Group.isGroup = isGroup;
})(Group || (Group = {}));
//# sourceMappingURL=group.js.map